/**
 * Room Condition Report settings schema.
 *
 * The one setting is `sendTimes`: the times of day the scheduled report is sent.
 * It is a variable-length list, so it uses the `repeater` field type with a
 * `time` item. It is a delivery-schedule setting (the backend reads only the
 * hour of each entry), so it lives under a template-only "Scheduled Delivery"
 * section -- an on-demand run does not schedule anything.
 *
 * Storage note: the backend has historically stored each send time as a full
 * datetime string (or an hour), while the `time` field reads/writes "HH:mm".
 * GroupRoomConditionReport normalises whatever is stored to "HH:mm" before the
 * panel sees it (see its prepareSettingsFunction), so existing templates edit
 * correctly and new ones save "HH:mm"; the backend's Carbon::parse(...)->hour
 * accepts either.
 */
export default {
    slug: 'room-condition-report',
    icon:
        '<path stroke="none" d="M0 0h24v24H0z" fill="none"/>'
        + '<path d="M3 21l18 0" />'
        + '<path d="M9 8l1 0" />'
        + '<path d="M9 12l1 0" />'
        + '<path d="M9 16l1 0" />'
        + '<path d="M14 8l1 0" />'
        + '<path d="M14 12l1 0" />'
        + '<path d="M14 16l1 0" />'
        + '<path d="M5 21v-16a2 2 0 0 1 2 -2h10a2 2 0 0 1 2 2v16" />',
    permission: 'manage_room_condition_report',
    title: 'Room Condition',
    description: 'See what each zone is reading at a set time, and whether anything is out of range.',
    info: 'Shows each SoniShield View in the selected zones with its room name and latest pressure, temperature and humidity readings, next to the allowed range. Readings at or past a caution or alarm limit are shown in red.',

    sections: [
        {
            // Template-only: this report is defined by its delivery schedule. An
            // on-demand run picks its zones and window on the run form instead.
            title: 'Scheduled Delivery',
            description: 'The times of day this report is sent.',
            showIf: ({isSavable}) => isSavable === true,
            fields: [
                {
                    key: 'sendTimes',
                    type: 'repeater',
                    label: 'Times to send each day',
                    description: 'The times of day this report is scheduled to be emailed. Only the hour is used.',
                    itemType: 'time',
                    itemLabel: 'send time',
                    addText: 'Add a send time',
                    emptyText: 'No send times set. Add one to schedule this report.',
                    default: '07:00',
                },
            ],
        },
    ],
}
